import React from 'react';
import './AboutNationalHistory.scss';
import Reveal from '../Reveal/Reveal';
// Import the Theta Tau coat of arms logo
import logo from '../../images/IconsLogos/ttcoatarms.png';
// Historical chapter photograph — the installation photo
import installationimg from '../../images/BackgroundImages/installation.JPEG';

// Component that displays the national history of Theta Tau fraternity
// Shows the founding story and current status of the organization
function AboutNationalHistory() {
    return (
      <section className="national-history" aria-labelledby="national-history-heading">
        {/* Title for the national history section */}
        <div className="national-history-heading">
          <Reveal as="h2" id="national-history-heading" variant="mask">National Theta Tau History</Reveal>
        </div>
        {/* Content area with logo and historical text */}
        <div className="national-history-content">
            {/* Theta Tau coat of arms logo */}
            <Reveal as="img" variant="rise" index={1} className="national-history-img" src={logo} alt="logo"/>
            {/* Paragraph containing the founding story and current information */}
            <Reveal as="p" variant="rise" index={2} className="national-history-par">
            On October 15, 1904, Erich J. Schrader, Elwin L. Vinyl, William M. Lewis, and Isaac B. Hanks founded "The Society of Hammer and Tongs"
            at the University of Minnesota in Minneapolis, Minnesota. It wasn't until the first National convention was held at the University of
            Minnesota in 1911 that the Greek letters "Theta Tau" were formally adopted. Today, with over 40,000 members initiated, Theta Tau has
            become one of the largest and foremost professional engineering fraternities. Currently, Theta Tau has established branches on over 100
            college campuses, representing men and women across all engineering disciplines and backgrounds.
            </Reveal>
        </div>
        {/* Historical chapter photograph — a quiet closing plate for the founding story */}
        <Reveal as="div" variant="plate" index={3} className="national-history-plate">
            <img src={installationimg} alt="" loading="lazy" />
        </Reveal>
      </section>
    );
}

export default AboutNationalHistory;
